import { API_URL, SITE_CODE } from "./config";
import axios from "axios";

export const getEarthquakeInformation = (callback) => {
  axios
    .get(`${API_URL}/api/analysis/get_earthquake_information/${SITE_CODE}`)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};
